import type { IContainer } from '@monofe/di';
import { injectOrBuildContainer } from '@monofe/di';
import TYPES from '../util/types';
import type { MimeType } from './mimeType';

export enum IFeatureStatus {
    FeatureStatusUndef = 0,
    FeatureStatusUnsupported = 1,
    FeatureStatusUnknown = 2,
    FeatureStatusSupported = 3,
    FeatureStatusLastValue = 4,
}

export enum IFeatureType {
    FeatureTypeUndef = 0,
    FeatureTypeSymbol = 1,
    FeatureTypeModule = 2,
    FeatureTypeIndexedDB = 3,
    FeatureTypeLastValue = 4,
}

export interface IFeatureQuery {
    mediaSupported: (mimeTypes: MimeType[]) => Promise<IFeatureStatus>;
    featuresSupported: (features: IFeatureType[]) => Promise<IFeatureStatus>;
}

export function injectFeatureQuery(
    container: IContainer = injectOrBuildContainer(),
): IFeatureQuery {
    return container.get<IFeatureQuery>(TYPES.IFeatureQuery);
}

export function bindFeatureQuery(
    val: IFeatureQuery,
    container: IContainer = injectOrBuildContainer(),
): void {
    container.bind<IFeatureQuery>(TYPES.IFeatureQuery, val);
}

export function unbindFeatureQuery(container: IContainer = injectOrBuildContainer()): void {
    container.remove(TYPES.IFeatureQuery);
}
